import { useLog } from '@/hooks/V3/useLog';
import { useAppSelector } from '@/redux/store';
import { initUser } from '@/redux/userSlice';
import { useDispatch } from 'react-redux';
import { useLocalStorage } from 'usehooks-ts';

const SignOutContainer = () => {
  const [_, setCplatToken] = useLocalStorage('cplatToken', '');
  const dispatch = useDispatch();
  const user = useAppSelector((state) => state.user);
  const { setUserEventHistory } = useLog(user.UserNo);

  const handleSignOut = () => {
    setCplatToken('');
    dispatch(initUser());
    setUserEventHistory({
      eventName: 'logout',
    });
  };

  return (
    <p className="cursor-pointer" onClick={handleSignOut}>
      로그아웃
    </p>
  );
};

export default SignOutContainer;
